module.exports = __webpack_public_path__ + "img/usuario.b0d32d76.png";